module.exports = __webpack_public_path__ + "img/18.7.B.68c00692.png";